module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.currForm,
      "label-width": "80px",
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "disabled": !_vm.edit,
      "placeholder": "最多20个字"
    },
    model: {
      value: (_vm.currForm.name),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "name", $$v)
      },
      expression: "currForm.name"
    }
  }), _vm._v(" "), (_vm.currForm.id) ? _c('span', [_vm._v("当前装配人数：" + _vm._s(_vm.currForm.countUsed))]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "贴纸",
      "prop": "content"
    }
  }, [(_vm.edit) ? _c('UploadDragImg', {
    attrs: {
      "disabled": _vm.edit,
      "tips": "（尺寸：155*155，jpg、png）",
      "imgUrl": _vm.currForm.content
    },
    on: {
      "update:imgUrl": function($event) {
        return _vm.$set(_vm.currForm, "content", $event)
      },
      "update:img-url": function($event) {
        return _vm.$set(_vm.currForm, "content", $event)
      }
    }
  }) : _c('img', {
    attrs: {
      "width": "360",
      "height": "180",
      "src": _vm.currForm.content,
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示排序",
      "prop": "sort"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "disabled": !_vm.edit
    },
    model: {
      value: (_vm.currForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "sort", $$v)
      },
      expression: "currForm.sort"
    }
  }), _vm._v(" "), _c('div', [_vm._v("数字越大越靠前")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "拥有学生"
    }
  }, [_c('SelectStudent', {
    ref: "SelectStudentRef",
    attrs: {
      "disabled": _vm.edit,
      "selectVal": _vm.currForm.useType,
      "privileges": _vm.currForm.privilegeRole
    },
    on: {
      "update:selectVal": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      },
      "update:select-val": function($event) {
        return _vm.$set(_vm.currForm, "useType", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角标图片"
    }
  }, [_c('SUpload', {
    attrs: {
      "accept": "image/*",
      "type": "drag",
      "size": 50,
      "disabled": !_vm.edit,
      "show-file-list": false
    },
    model: {
      value: (_vm.currForm.superscript),
      callback: function($$v) {
        _vm.$set(_vm.currForm, "superscript", $$v)
      },
      expression: "currForm.superscript"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("尺寸建议40*40，最大50KB，优先SVG其次png")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-735d3257!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/UserAdminister/PersonalizedPart/Components/PosterSticker.vue
// module id = 1072
// module chunks = 0